import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "universal-cookie";

ReactModal.setAppElement("#root");

const ModalComentario = ({
  isOpen,
  onClose,
  solicitudId,
  usuarioId,
  onComentarioCreado,
}) => {
  const [comentario, setComentario] = useState("");
  const [loading, setLoading] = useState(false);
  const cookie = new Cookies();

  const guardarComentario = async () => {
    if (!comentario.trim()) {
      Swal.fire("Atención", "El comentario no puede estar vacío", "warning");
      return;
    }

    setLoading(true);

    try {
      await axios.post(
        "https://suadesarrollo.azurewebsites.net/api/JuntaDirectiva/CreaComentarios",
        {
          SolicitudId: solicitudId,
          UsuarioId: cookie.get("id"),
          Comentarios: comentario,
        },
      );

      Swal.fire("Éxito", "Comentario creado correctamente", "success");

      setComentario("");
      onComentarioCreado();
      onClose();
    } catch (error) {
      console.error(error);

      Swal.fire(
        "Error",
        error.response?.data || "Error al crear comentario",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        overlay: {
          backgroundColor: "rgba(0,0,0,0.5)",
          zIndex: 9999,
          display: "flex",
          alignItems: "center", // 🔥 centra vertical
          justifyContent: "center", // 🔥 centra horizontal
        },
        content: {
          position: "relative",
          inset: "unset",
          width: "700px", // 🔥 MÁS ANCHO
          maxWidth: "90%",
          borderRadius: "10px",
          padding: "0",
        },
      }}
    >
      <div className="modal-content">
        <div className="modal-header bg-primary text-white">
          <h5 className="modal-title">Nuevo Comentario</h5>
          <button className="close" onClick={onClose}>
            <span>&times;</span>
          </button>
        </div>

        <div className="modal-body">
          <textarea
            className="form-control"
            rows="5" // 🔥 más alto
            placeholder="Escriba su comentario..."
            value={comentario}
            onChange={(e) => setComentario(e.target.value)}
          />
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Cancelar
          </button>
          <button
            className="btn btn-primary"
            onClick={guardarComentario}
            disabled={loading}
          >
            {loading ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>
    </ReactModal>
  );
};

export default ModalComentario;
